import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import { translate } from 'javascripts/translations/i18n';
import { ActionLink } from 'components/shared';
import { Button } from '@companycam/slab-web';

const VERSION_ORIGINAL = 'original';
const VERSION_MODIFIED = 'modified';
type Version = typeof VERSION_ORIGINAL | typeof VERSION_MODIFIED;

type SingleDownloadModalProps = {
  photo: { id: any; url_large_original: string; url_large: string };
  isOpen: boolean;
  onRequestClose: () => void;
  companyId: number;
};

const SingleDownloadModal = ({
  photo,
  isOpen,
  onRequestClose,
  companyId,
}: SingleDownloadModalProps) => {
  const isModified = photo && photo.url_large_original !== photo.url_large;
  const formRef = useRef(null);
  const [version, setVersion] = useState<Version>(VERSION_ORIGINAL);

  const handleDownloadClicked = (v: Version) => {
    setVersion(v);
    // this gives enough time for the form to render
    setTimeout(() => formRef.current?.submit(), 200);
  };

  useEffect(() => {
    if (isOpen && !isModified) {
      handleDownloadClicked(VERSION_ORIGINAL);
    }
  }, [isOpen, isModified]);

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      contentLabel={translate('photos.singleDownloadModal.modalLabel')}
      overlayClassName="modal"
      className="modal-content-wrap"
    >
      <ActionLink className="modal-close-button" onClick={onRequestClose}>
        <i className="mdi mdi-close" />
      </ActionLink>
      <div>
        <div>
          <h3 className="modal-title">
            {isModified
              ? translate('photos.singleDownloadModal.downloadPhoto')
              : translate('photos.singleDownloadModal.downloadInprogress')}
          </h3>
          <form
            ref={formRef}
            action={`/companies/${companyId}/downloads`}
            method="POST"
          >
            <input type="hidden" name="image_id" value={photo.id} />
            <input
              style={{ visibility: 'hidden', display: 'none' }}
              type="checkbox"
              name="annotated"
              checked={version === VERSION_MODIFIED}
            />
            <span className="instructions">
              {isModified
                ? translate('photos.singleDownloadModal.modified')
                : translate('photos.singleDownloadModal.downloadPending')}
            </span>
            <div className="btn-container full">
              {isModified ? (
                <>
                  <Button
                    color="primary"
                    onClick={() => handleDownloadClicked(VERSION_ORIGINAL)}
                  >
                    {translate('common.downloadOriginal')}
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => handleDownloadClicked(VERSION_MODIFIED)}
                  >
                    {translate('common.downloadModified')}
                  </Button>
                </>
              ) : null}
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default SingleDownloadModal;
